export enum EInvoiceStatus {
  Active = 'ACTIVE',
  Refused = 'REFUSED',
  Suspended = 'SUSPENDED',
  Disputed = 'DISPUTED',
  Completed = 'COMPLETED',
  Approved = 'APPROVED',
  PaymentReceived = 'PAYMENT_RECEIVED',
}
